import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const RemoveMonitoringContext = createContext(null);

type Props = {
  children: ReactElement;
};

const RemoveMonitoringProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.delete(`user_monitoring/remove`, {
        data: payload,
      });
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      isPending,
      error,
    }),
    [mutateAsync, data, isPending, error],
  );
  return (
    <RemoveMonitoringContext.Provider value={contextValue}>
      {children}
    </RemoveMonitoringContext.Provider>
  );
};

export default RemoveMonitoringProvider;
